import { useState } from 'react';
import { Modal, Dropdown, Form, Accordion, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  activateLoader,
  deactivateLoader,
  updateMemberData,
} from '../../actions/team';
import { roleAndPermissionsService, teamService } from '../../services';
import { TEAM, API_FAILURE_ERROR } from '../../constants';
import { AccordionToggleWithButtonForRole } from '../common';

function RemoveRoleModal({ userId, customRole, typeId }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedExtraPermission, setSelectedExtraPermission] = useState([]);
  const [toggleArrowChange, arrowChange] = useState(false);
  const arrowChangeToggle = () => {
    arrowChange(!toggleArrowChange);
  };

  // Remove the assigned role
  const handleStatusUpdate = () => {
    dispatch(activateLoader());
    const params = {
      teamMemberId: userId,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      customRoleId: customRole,
    };
    roleAndPermissionsService
      .remove_member_role(params)
      .then((response) => {
        if (response) {
          teamService
            .get_team_members_data({
              teamOwnerId: localStorage.getItem('teamOwnerId'),
              summaryList: false,
              filter: JSON.stringify({
                memberId: userId,
              }),
            })
            .then((responses) => {
              if (responses.data) {
                const { members } = responses.data;

                dispatch(updateMemberData(members[0]));

                toast.success(TEAM.ROLE_REMOVE_SUCCESS);
                handleClose();
              }
            });
        }
        dispatch(deactivateLoader());
      })
      .catch((errResponse) => {
        dispatch(deactivateLoader());
        if ('message' in errResponse) {
          toast.error(errResponse.message);
        } else {
          toast.error(API_FAILURE_ERROR);
        }
      });
  };

  const getExtraPermission = () => {
    handleShow();
    const newParam = {
      roleId: customRole,
      userTypeId: typeId,
    };

    roleAndPermissionsService
      .get_role(newParam)
      .then((res) => {
        if (res && res.data && res.data.length) {
          const permissionsListFilterd = res.data;
          const permissionLists = JSON.parse(
            JSON.stringify(
              permissionsListFilterd.filter((item) => item.isSelected)
            )
          );
          const groupByModuleName = Object.groupBy(
            permissionLists,
            ({ moduleName }) => moduleName
          );
          const extraPermissionList = Object.keys(groupByModuleName).map(
            (itemname) => ({
              name: itemname,
              list: groupByModuleName[itemname],
            })
          );
          setSelectedExtraPermission(extraPermissionList);
        }
      })
      .catch((errResponse) => {
        dispatch(deactivateLoader());
        if ('message' in errResponse) {
          toast.error(errResponse.message);
        } else {
          toast.error(API_FAILURE_ERROR);
        }
      });
  };

  return (
    <>
      <Dropdown.Item onClick={getExtraPermission}>Remove Role</Dropdown.Item>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="md"
        centered
      >
        <Modal.Header>
          <Modal.Title className="m-0">Remove Role</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
        </Modal.Header>
        <Formik
          initialValues={{
            deactivateReason: '',
          }}
          validationSchema={Yup.object({
            deactivateReason: Yup.string()
              .trim()
              .required('Please enter reason for deactivation'),
          })}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <section>
                <div id="load_members">
                  <div className="modal-body">
                    <p className="text-muted text-sm">
                      Removing this role will remove all the following
                      additional permissions. You can re-assign the role from
                      manage role page.
                    </p>
                    <div
                      className="overflow-auto mb-0 mt-3"
                      style={{ maxHeight: '200px' }}
                    >
                      <div className="card mb-0">
                        <div className="card-body p-0">
                          <ul className="list-group list-group-flush pe-0">
                            <Accordion
                              defaultActiveKey="0"
                              className="accordion-flush"
                            >
                              {selectedExtraPermission &&
                                selectedExtraPermission.length > 0 &&
                                selectedExtraPermission.map(
                                  (permission, index) => (
                                    <li className="list-group-item" key={index}>
                                      <Row>
                                        <Col className="px-2">
                                          <div className="d-flex justify-content-start text-capitalize">
                                            <b>{permission.name}</b>
                                          </div>
                                        </Col>
                                        <Col sm lg="1">
                                          <div className="d-flex justify-content-end">
                                            <AccordionToggleWithButtonForRole
                                              eventKey={index + 1}
                                              callback={arrowChangeToggle}
                                            />
                                          </div>
                                        </Col>
                                      </Row>

                                      <Accordion.Collapse eventKey={index + 1}>
                                        <div className="p-2">
                                          {permission.list &&
                                            permission.list.length > 0 &&
                                            permission.list.map((item, i) => (
                                              <div className="mt-1" key={i}>
                                                {item.permissionNameUI
                                                  .toLowerCase()[0]
                                                  .toUpperCase() +
                                                  item.permissionNameUI
                                                    .toLowerCase()
                                                    .substring(1)}
                                              </div>
                                            ))}
                                        </div>
                                      </Accordion.Collapse>
                                    </li>
                                  )
                                )}
                            </Accordion>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-link"
                      data-dismiss="modal"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary  ml-auto"
                      name="btnDeactivateMemberCard"
                      onClick={handleStatusUpdate}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
RemoveRoleModal.propTypes = {
  userId: PropTypes.string,
  customRole: PropTypes.string,
  typeId: PropTypes.string,
};

export default RemoveRoleModal;
